'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Number1IconXl } from '@lichtblick/icons/svg/number-1/number-1-xl';
import { Number2IconXl } from '@lichtblick/icons/svg/number-2/number-2-xl';
import { Number3IconXl } from '@lichtblick/icons/svg/number-3/number-3-xl';
import { Number4IconXl } from '@lichtblick/icons/svg/number-4/number-4-xl';
import { Number5IconXl } from '@lichtblick/icons/svg/number-5/number-5-xl';
import { Headline } from '@lichtblick/photon/atoms/headline/headline';
import utilityStyles from '@lichtblick/photon/theme/utilities.module.scss';
import classNames from 'classnames';
import { useMemo } from 'react';
import { RichText } from '../../../helpers/RichText';
import { AButton } from '../../AButton';
import styles from './four-steps.module.scss';
import { Step, Steps } from './Steps/Steps';
const icons = [
    Number1IconXl,
    Number2IconXl,
    Number3IconXl,
    Number4IconXl,
    Number5IconXl
];
const titleElementMappers = {
    p: ({ children })=>/*#__PURE__*/ _jsx(Headline, {
            renderAs: "h2",
            size: "m",
            children: children
        })
};
export const FourSteps = ({ button, steps, theme, title })=>{
    const stepsElementMappers = useMemo(()=>({
            ol: ({ children })=>/*#__PURE__*/ _jsx(Steps, {
                    children: children
                }),
            li: ({ children, i })=>{
                return children && i < icons.length ? /*#__PURE__*/ _jsx(Step, {
                    theme: theme || 'white',
                    icon: icons[i],
                    text: children
                }) : null;
            }
        }), [
        theme
    ]);
    return /*#__PURE__*/ _jsxs("section", {
        className: classNames(styles.section, utilityStyles[`theme-bg-${theme || 'white'}`]),
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: styles.title,
                children: title && /*#__PURE__*/ _jsx(RichText, {
                    elementMappers: titleElementMappers,
                    richText: title
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: styles.content,
                children: [
                    steps && /*#__PURE__*/ _jsx(RichText, {
                        elementMappers: stepsElementMappers,
                        richText: steps
                    }),
                    button?.length === 1 && /*#__PURE__*/ _jsx("div", {
                        className: styles.button,
                        children: /*#__PURE__*/ _jsx(AButton, {
                            ...button[0]
                        })
                    })
                ]
            })
        ]
    });
};

//# sourceMappingURL=four-steps.js.map